import(/* webpackMode: "eager" */ "/Users/yoko/renehuemer.com/website/src/app/art/[slug]/error.tsx");
